import { TOIAppEnvironmentVars, TReportingEnvironmentVars } from '@monorepo/types';

export const environment: TOIAppEnvironmentVars = {
  appType: 'OI_APP',
  production: false,
  mode: 'kalpha',
  environmentName: 'Kalpha Environment',
  ionicEnvName: 'kalpha',
  protocol: 'https://',
  ws_protocol: 'ws://',
  service_host: 'analytics.kalpha.strawmine.com',
  ws_host: 'no_url',
  ws_api: 'no_url',
  machine_maintenance: '/machine-maintenance/ext',
  auth_services: '/app_auth_services/ext',
  data_services: '/app_data_services',
  core_service: '/app_core_services/ext',
  data_gateway: '/app_data_gateway_n2/ext',
  image_service: '/app_image_service/ext',
  shift_service: '/app_shift_services/ext',
  fabric_inpsection_service: '/fabric_inspection/ext',
  unified_login: 'auth.strawmine.com',
};

export const reportsEnvironment: TReportingEnvironmentVars = {
  appType: 'OI_APP',
  reports_host: environment.service_host,
  reports_data_gateway: environment.data_gateway,
  protocol: environment.protocol,
};
